import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { CompositeProfileType } from '../models/CompositeProfileType';

const COMPOSITE_PROFILE_TYPE_LABELS: Record<CompositeProfileType, string> = {
    [CompositeProfileType.CompositeProfile]: 'Composite Profile',
    [CompositeProfileType.PAG]: 'PAG',
    [CompositeProfileType.PerfilDeFacies]: 'Perfil de Fácies',
};

const COMPOSITE_PROFILE_TYPE_OPTIONS = (
    Object.values(CompositeProfileType).filter((enumValue) => typeof enumValue === 'number') as CompositeProfileType[]
);

interface ICompositeProfileTypeSelectProps {
    value: CompositeProfileType;
    onChange: (event: SelectChangeEvent<CompositeProfileType>) => void;
    className?: string;
    size?: 'small' | 'medium';
}

export function CompositeProfileTypeSelect({ value, onChange, className, size }: ICompositeProfileTypeSelectProps) {
    return (
        <FormControl fullWidth className={className} size={size}>
            <InputLabel>Type</InputLabel>
            <Select<CompositeProfileType>
                value={value}
                label='Type'
                onChange={onChange}
                MenuProps={{ style: { zIndex: 1000000 } }}
            >
                {COMPOSITE_PROFILE_TYPE_OPTIONS.map((enumValue) => (
                    <MenuItem key={enumValue} value={enumValue}>
                        {COMPOSITE_PROFILE_TYPE_LABELS[enumValue]}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
